import { CMSData } from "@/cms/models";
import { useRouter } from "next/navigation";
import React from "react";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faMagnifyingGlass } from "@fortawesome/sharp-light-svg-icons";
interface SearchBarProps {
  showSearch?: boolean;
  cmsData: CMSData;
  toggleSearch: () => void;
}

const SearchBar: React.FC<SearchBarProps> = ({
  showSearch,
  cmsData,
  toggleSearch,
}) => {
  const router = useRouter();
  const [formData, setFormData] = React.useState({ q: "" });
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    toggleSearch();

    const query = formData.q.trim() ?? "";
    setFormData({ q: "" });

    const currentRoute = location?.pathname;
    const page = cmsData?.pages.find((x) => x.slug === currentRoute);
    const hasCaseList = page?.sections.some((x) => x.type === "CaseList");
    let defaultSearchPage = hasCaseList
      ? currentRoute
      : (cmsData?.defaultSearchPage ?? "/koeb");

    if (!defaultSearchPage.startsWith("/")) {
      defaultSearchPage = `/${defaultSearchPage}`;
    }

    if (formData.q.trim()) {
      router.push(`${defaultSearchPage}?q=${encodeURIComponent(query)}`);
    } else {
      router.push(defaultSearchPage);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div
      className={`bg-[var(--search-bg-color)] text-[var(--search-text-color)] lg:flex fixed top-0 z-30 right-0 w-full shadow-lg transform ${
        showSearch ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"
      } transition duration-300 ease-in-out`}
    >
      <div className="flex flex-col flex-1 gap-2 p-4">
        <div className="flex justify-end flex-1">
          <button
            aria-label="Close"
            className="text-[var(--search-close-button-text-color)] p-2 flex"
            onClick={() => toggleSearch()}
          >
            <FontAwesomeIcon className="size-[32px]" icon={faClose} />
          </button>
        </div>
        <div className="flex flex-1 justify-center items-center">
          <form
            noValidate
            onSubmit={handleSubmit}
            className="w-[600px] bg-white p-2 flex"
          >
            <input
              type="text"
              id="q"
              name="q"
              className="p-2 w-full text-gray-800 focus:outline-none"
              placeholder="Søg på sagsnr., by vej, postnr eller kommune"
              value={formData.q}
              onChange={handleChange}
            />
            <Button
              type="submit"
              className="bg-[var(--search-button-bg-color)] text-[var(--search-button-text-color)] hover:bg-[var(--search-button-hover-bg-color)] hover:text-[var(--search-button-hover-text-color)]"
            >
              <FontAwesomeIcon
                className="size-[24px]"
                icon={faMagnifyingGlass}
              />
              Søg
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
